import React from "react";
import { Link, LinkProps } from "react-router-dom";
import type { ButtonSize, ButtonVariant } from "./Button";

export type LinkButtonVariant = ButtonVariant | "trace";

export interface LinkButtonProps extends LinkProps {
  variant?: LinkButtonVariant;
  size?: ButtonSize;
}

const baseClasses =
  "inline-flex items-center justify-center gap-2 rounded-xl border font-semibold shadow-sm transition focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2";

const variantClasses: Record<LinkButtonVariant, string> = {
  primary:
    "border-[#2563EB] bg-[#2563EB] text-white hover:border-[#1D4ED8] hover:bg-[#1D4ED8] focus-visible:outline-[#2563EB]",
  secondary:
    "border-[#E2E8F0] bg-white text-[#0F172A] hover:border-[#2563EB] hover:bg-[#EFF6FF] hover:text-[#2563EB] focus-visible:outline-[#2563EB]",
  trace:
    "border-[#0D9488] bg-[#0D9488] text-white hover:border-[#0F766E] hover:bg-[#0F766E] focus-visible:outline-[#0D9488]",
  success:
    "border-[#0D9488] bg-[#0D9488] text-white hover:border-[#0F766E] hover:bg-[#0F766E] focus-visible:outline-[#0D9488]",
  danger:
    "border-[#FECACA] bg-white text-[#DC2626] hover:border-[#FCA5A5] hover:bg-[#FEF2F2] focus-visible:outline-[#DC2626]",
  ghost:
    "border-transparent bg-transparent text-[#64748B] shadow-none hover:bg-[#F6F8FB] hover:text-[#0F172A] focus-visible:outline-[#2563EB]",
  soft: "border-[#BFDBFE] bg-[#EFF6FF] text-[#2563EB] hover:border-[#93C5FD] hover:bg-[#DBEAFE] focus-visible:outline-[#2563EB]",
};

const sizeClasses: Record<ButtonSize, string> = {
  sm: "min-h-9 px-3 py-1.5 text-sm",
  md: "min-h-10 px-3.5 py-2 text-sm",
  lg: "min-h-11 px-4 py-2.5 text-base",
};

export default function LinkButton({
  variant = "secondary",
  size = "sm",
  className = "",
  children,
  ...props
}: LinkButtonProps) {
  return (
    <Link
      className={`${baseClasses} ${variantClasses[variant]} ${sizeClasses[size]} ${className}`.trim()}
      {...props}
    >
      {children}
    </Link>
  );
}
